import React, { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { API_URL } from "../../actions/settings";
import NotificationPopUp from "../../components/extras/NotificationPopUp";
import { IonButton, IonContent } from "@ionic/react";
import Ae2Header from "../../components/AE2/Ae2Header";
import { Meter } from "../../interfaces/Meter";
import LoadingDots from "../../components/extras/LoadingDots";
import InternalMeterDataTable from "../../components/AE2/InternalMeterComponents/InternalMeterDataTable";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import { isStaff } from "../../components/extras/Functions";
import ModelIntervalDataTable from "../../components/AE2/InternalMeterComponents/ModelIntervalDataTable";

interface Params {
  id: string;
}

interface IProps {
}

async function getData(token: string, url: string) {
  return fetch(`${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Could not fetch data")
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Could not fetch data")
      });
}

const InternalMeter:FC<IProps> = (props) => {
    const { id } = useParams<Params>();
    const start_url = new URL (`${API_URL}/internal_meter_data/${id}?page=1`)  
    const [data, setData] = React.useState<any>(null);
    const [meter, setMeter] = React.useState<Meter | null>(null);
    const [url, setUrl] = useState(start_url)
    const [tableType, setTableType] = useState('data')
    const user = useAppSelector(selectUser)
    let params = new URLSearchParams(window.location.search);
    const url_tab = params.get('table_type')

    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const res = await getData(token, `${API_URL}/internal_meter_data/${id}?page=1`);
      if (res) {
        setData(res);
        setMeter(res.results.meter_data);
      }
    };
    handleData();
  },[id]);


    useEffect(()=>{
        if (url_tab){
          setTableType(url_tab)
          const button = document.querySelector(`#${url_tab}_meters_button`)
          button?.classList.add('selected')
        }
        else{
            setTableType('data')
            const button = document.querySelector(`#data_meters_button`)
            button?.classList.add('selected')
            window.history.replaceState(null,"",`${window.location.pathname}?table_type=data`)
        }
        
      },[url_tab])


    const handleFilters = (url:string) => {
    const handleData = async () => {
      setUrl(new URL(url));
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const res = await getData(token, url);
      if (res) {
        setData(res);
        setMeter(res.results.meter_data);
      }
    };
    handleData();
  }

    const handleMenuClick = (e:any, tab:string) => {
        setTableType(tab)
        params.set('table_type',tab)
        window.history.replaceState(null,"",`${window.location.pathname}?table_type=${tab}`)
    }
    return <IonContent className="main-background">
        <div style={{marginBottom:'150px'}}>
          <Ae2Header/>
            {!meter ? 
            <LoadingDots/> : 
            <>
            <h3>{meter?.name}</h3>
            { isStaff(user) ?
              <div style={{display:'flex',justifyContent:'center',marginBottom:'0.5rem',marginTop:'0.5rem'}}>
                <div style={{borderBottom:'1px solid white'}}>
                  <IonButton  id='estar_meters_button' 
                  className= { tableType === 'data' ?  "selected tab-menu-button" : 'tab-menu-button'}
                  fill='clear' color="light" 
                  onClick={(e)=>handleMenuClick(e,'data')}>Interval Data</IonButton>

                  <IonButton id='internal_meters_button' 
                  className={ tableType === 'model' ?  "selected tab-menu-button" : 'tab-menu-button'} 
                  fill='clear' color="light" onClick={(e)=>handleMenuClick(e,'model')}>Model Data</IonButton>                
              </div>
              </div> : null }
              {(() => {
                switch (tableType) {
                  case 'data': return data ? <InternalMeterDataTable data={data} name={meter?.name} units = {meter?.units} url={url} handleFilters = {handleFilters} setUrl={setUrl}/> : <p>No data available for this meter.</p> ;
                  case 'model': return data ? <ModelIntervalDataTable id={id}/> : <p>No data available for this meter.</p> ;                  
                  default:        return null;
                }
              })()}
            
            </>
            }
        </div>
    </IonContent>
};

export default InternalMeter;